import { useState } from "react";
import "@/styles/account.css";

const plans = [
  {
    plan: "Starter Monthly",
    basePrice: 29,
    suffix: "/mo",
    level1Rate: 0.2,
    level2Rate: 0.4,
  },
  {
    plan: "Starter Annual",
    basePrice: 278.4,
    suffix: "/yr",
    level1Rate: 0.2,
    level2Rate: 0.4,
  },
  {
    plan: "Agency Monthly",
    basePrice: 79,
    suffix: "/mo",
    level1Rate: 0.2,
    level2Rate: 0.4,
  },
  {
    plan: "Agency Annual",
    basePrice: 758.4,
    suffix: "/yr",
    level1Rate: 0.2,
    level2Rate: 0.4,
  },
];

function formatCurrency(amount: number): string {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
}

export default function PartnersPage() {
  const [users, setUsers] = useState(1);

  return (
    <div className="account-cards">
      <div className="simple-page-card">
        <h2>Partner Program</h2>
        <p>
          Earn recurring commissions by referring customers to Zima Media MCP.
          Our two-tier partner program rewards affiliates with lifetime
          recurring revenue on every referred subscription.
        </p>
      </div>

      <div className="partner-tiers">
        <div className="partner-tier-card">
          <div className="partner-tier-badge tier-affiliate">Level 1</div>
          <h3>Affiliate</h3>
          <div className="partner-tier-commission">20%</div>
          <div className="partner-tier-label">Recurring Commission</div>
          <ul className="partner-tier-perks">
            <li>Lifetime recurring revenue on all referrals</li>
            <li>Up to 30% discount codes for your audience</li>
            <li>Personal referral link and tracking dashboard</li>
            <li>Approved after manual review</li>
          </ul>
        </div>

        <div className="partner-tier-card featured">
          <div className="partner-tier-badge tier-partner">Level 2</div>
          <h3>Partner</h3>
          <div className="partner-tier-commission">40%</div>
          <div className="partner-tier-label">Recurring Commission</div>
          <ul className="partner-tier-perks">
            <li>Everything in Level 1, plus higher commissions</li>
            <li>Up to 50% discount codes for enterprise deals</li>
            <li>Priority support and co-marketing opportunities</li>
            <li>Promoted after 10 referrals + partner meeting</li>
          </ul>
        </div>
      </div>

      <div className="simple-page-card">
        <h2>Earnings Calculator</h2>
        <p>
          See how much you can earn. Drag the slider to see your potential
          recurring revenue.
        </p>

        <div className="partner-slider-wrap">
          <div className="partner-slider-header">
            <span className="partner-slider-label">Referred Users</span>
            <span className="partner-slider-value">{users}</span>
          </div>
          <input
            type="range"
            min={1}
            max={10}
            value={users}
            onChange={(e) => setUsers(Number(e.target.value))}
            className="partner-slider"
          />
          <div className="partner-slider-range">
            <span>1</span>
            <span>10</span>
          </div>
        </div>

        <div className="partner-table-wrap">
          <table className="partner-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Price</th>
                <th>Level 1 (20%)</th>
                <th>Level 2 (40%)</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((row) => (
                <tr key={row.plan}>
                  <td>{row.plan}</td>
                  <td>
                    {formatCurrency(row.basePrice)}
                    {row.suffix}
                  </td>
                  <td>
                    {formatCurrency(row.basePrice * row.level1Rate * users)}
                    {row.suffix}
                  </td>
                  <td className="highlight">
                    {formatCurrency(row.basePrice * row.level2Rate * users)}
                    {row.suffix}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="simple-page-card">
        <h2>How It Works</h2>
        <div className="partner-steps">
          <div className="partner-step">
            <div className="partner-step-num">1</div>
            <div>
              <strong>Apply</strong>
              <p>
                Reach out through our contact page. All applications are
                manually reviewed.
              </p>
            </div>
          </div>
          <div className="partner-step">
            <div className="partner-step-num">2</div>
            <div>
              <strong>Share</strong>
              <p>
                Get your unique referral link and discount codes to share with
                your audience.
              </p>
            </div>
          </div>
          <div className="partner-step">
            <div className="partner-step-num">3</div>
            <div>
              <strong>Earn</strong>
              <p>
                Earn recurring commissions for the lifetime of every referred
                customer.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="partner-cta-section">
        <a
          href="https://partners.zimamedia.com"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary partner-cta-btn"
        >
          Become a Partner
        </a>
        <p className="partner-cta-sub">
          Already a partner?{" "}
          <a
            href="https://partners.zimamedia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="partner-dashboard-link"
          >
            Go to Partner Dashboard
          </a>
        </p>
      </div>
    </div>
  );
}
